<ion-header>
  <ion-toolbar>
    <ion-title>{{'CHANGE_PASSWORD' | translate }}</ion-title>
    <!-- <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <span ion-text color="primary" when="ios">{{'CANCEL' | translate}}</span>
        <ion-icon name="close" showWhen="android, windows"></ion-icon>
      </ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="form" (ngSubmit)="save()">
    <ion-item fill="outline">
      <ion-label position="floating">{{"PASSWORD"| translate}} *</ion-label>
      <ion-input formControlName="password" type="password"></ion-input>
    </ion-item>
    <app-form-error [control]="form.controls.password" [minLength]="12" [maxLength]="80"></app-form-error>
    <ion-item fill="outline">
      <ion-label position="floating">{{"CONFIRM_PASSWORD" | translate}} *</ion-label>
      <ion-input formControlName="confirmPassword" type="password"></ion-input>
    </ion-item>
    <app-form-error [control]="form.controls.confirmPassword" [minLength]="12" [maxLength]="80"></app-form-error>
  </form>
</ion-content>
<ion-footer>
  <ion-button *ngIf="form" expand="block" color="primary" type="submit" [disabled]="form.invalid" (click)="save()">
    {{'VALIDATE' | translate}}
  </ion-button>
</ion-footer>